import "./Shop.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Listings from "./sections/Listings";
export default function ShopPage() {
  return <div>
      <Header />
      <Hero />
      <Listings />
    </div>;
}